import type marketingPreferencesAPIClient from '../infrastructure/marketingPreferencesAPIClient'
import type { marketingPreferencesStore } from '../infrastructure/store'
import { MarketingPreferencesData } from './types'

function marketingPreferencesUseCases({
  apiClient,
  store,
}: {
  apiClient: typeof marketingPreferencesAPIClient
  store: typeof marketingPreferencesStore
}) {
  let bannerTimer: ReturnType<typeof setTimeout> | null = null

  async function updatePreferences(formData: MarketingPreferencesData) {
    const state = store.getState()
    state.setIn('savePreferences.loading', true)
    state.setIn('savePreferences.error', false)
    state.setIn('savePreferences.success', false)
    try {
      const { success } = await apiClient.updateMarketingPreferences(formData)
      state.setIn('savePreferences', {
        loading: false,
        error: !success,
        success: !!success,
      })
    }
    catch {
      state.setIn('savePreferences', {
        loading: false,
        error: true,
        success: false,
      })
    }
    finally {
      state.setIn('savePreferences.loading', false)

      if (bannerTimer)
        clearTimeout(bannerTimer)
      bannerTimer = setTimeout(() => {
        state.setIn('savePreferences.success', false)
        state.setIn('savePreferences.error', false)
        bannerTimer = null
      }, 5000)
    }
  }

  return { updatePreferences }
}

export default marketingPreferencesUseCases
